var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"login\"><div class=\"wrapper-main reset-page resetpass\"><div class=\"container resetpass-success-container active\"><img" + (jade.attr("src", require('./success-group.svg'), true, true)) + " width=\"95\"><h2>Success!</h2><p>You've successfully updated your password.</p><a ng-click=\"go_to_login()\" class=\"button\">Go to Login</a></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/password_reset_done/password_reset_done.jade
// module id = 566
// module chunks = 0